//import services from './../services/service'; // Service Class
//let service = new services();

export default {
    name: 'Settings',
    data () {
      return {
        disable_btn:false,
        action_loading:false,
        copied:false,
        //
        site_view:1,//default
      }
  },

    methods: {
        back(){
            window.history.back();
        },
        
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        formatCurrency(currency){
            currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
            currency =  currency.replace("₦", "") //if sign showing as in Edge browser
            currency =  currency.replace("NGN", ""); //strip off NGN
            return currency;
        },

        formatCurrency_2(currency){
            currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
            currency =  currency.replace("₦", "") //if sign showing as in Edge browser
            currency =  currency.replace("NGN", ""); //strip off NGN
            currency =  currency.replace(".00", ""); //strip off NGN
            currency =  currency.replace(" ", ""); //strip off any space
            return currency;
        },

        copyLink(link,id) {
            this.$clipboard(link);
            this.copied = true;
            document.getElementById(id).style.display = "block";
        },

        toggleSingleComponent(component){
            let toggle = document.getElementById(component).style.display;
            if(toggle == "block"){
                document.getElementById(component).style.display = "none";
            }else{
                document.getElementById(component).style.display = "block";
            }
        },

        displayOnComponent(component){
            document.getElementById(component).style.display = "block";
        },

        displayOffComponent(component){
            document.getElementById(component).style.display = "none";
        },

        jumpToView(component){
            const element = document.getElementById(component);
            element.scrollIntoView(false);
            element.scrollIntoView(({ behavior: "smooth", block: "end", inline: "nearest" }))
        },

        scrollPageTop(){
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },

        setScreenView(){
            //set screen view
            var x = window.matchMedia("(max-width: 700px)")
            //this.screenFunction(x);
            if (x.matches) { // If media query matches
                this.site_view = 1;
            } else {
                this.site_view = 2;
            }
        },

        setMenuActive(menu_class,index){
            var elements = document.getElementsByClassName(menu_class);
            for (var i = 0; i < elements.length; i++) {
                elements[i].className = menu_class;
                //elements[i].className.replace("-active", '');
                if(index == i){
                    elements[i].className += " "+menu_class+"-active";
                    //elements[i].className = menu_class+" "+menu_class+"-active";
                }
            }
        },

        checkDateInCurrentWeek(date) {
            const todayObj = new Date();
            const todayDate = todayObj.getDate();
            const todayDay = todayObj.getDay();
          
            // get first date of week
            const firstDayOfWeek = new Date(todayObj.setDate(todayDate - todayDay));
          
            // get last date of week
            const lastDayOfWeek = new Date(firstDayOfWeek);
            lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 6);
          
            // if date is equal or within the first and last dates of the week
            return date >= firstDayOfWeek && date <= lastDayOfWeek;
        },
    },
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/resources/setts.js